import { initComponent } from './core/init-component.js'
import { addToCart, reRenderShopifySections } from '../components/src/lib/utils'
import { openCart } from './utils/cart.js'

initComponent('.js-ls-product-card', card => {
  const atcButton = card.querySelector('.js-ls-product-card-atc')
  const quickViewButton = card.querySelector('.js-quick-view-button')

  const setLoadingState = (isLoading) => {
    if (!atcButton) return

    atcButton.disabled = isLoading

    atcButton.classList.toggle('opacity-60', isLoading)
    atcButton.classList.toggle('pointer-events-none', isLoading)
  }

  async function addToCartAction(variantId, properties = {}) {
    if (!variantId) return

    const payload = {
      items: [
        {
          id: parseInt(variantId, 10),
          quantity: 1,
          properties
        }
      ]
    }

    try {
      setLoadingState(true)
      await reRenderShopifySections(await addToCart(payload))
      openCart()
    } catch (error) {
      console.error('Add to cart failed:', error)
    } finally {
      setLoadingState(false)
    }
  }

  quickViewButton?.addEventListener('click', e => {    
    e.preventDefault()

    const productId = quickViewButton.dataset.productId
    const variantId = quickViewButton.dataset.variantId
    const hasMultipleVariants = quickViewButton.hasAttribute('data-has-multiple-variants')

    if (!productId) return

    if (hasMultipleVariants) {      
      document.dispatchEvent(
        new CustomEvent('openQuickView', { detail: { productId } })
      )
    } else {
      addToCartAction(variantId)
    }
  })

  atcButton?.addEventListener('click', async e => {
    e.preventDefault()

    const variantId = atcButton.getAttribute('data-product-id')
    if (!variantId) return

    let properties = {}
    const lineProperties = atcButton.getAttribute('data-line-properties')
    if (lineProperties) {
      try {
        properties = JSON.parse(lineProperties)
      } catch (err) {
        console.warn('Failed to parse line properties JSON', err)
      }
    }

    addToCartAction(variantId, properties)
  })
})
